import React, { useContext } from 'react'

import type { IProductState, ISku } from './model'

const sku = {
  data: [],
  loading: true,
  error: null,
  refetch: (): void => void 0,
}
const updateProduct = (): void => void 0

export const initialState: IProductState = {
  sku,
  updateProduct,
}

export const ProductContext = React.createContext(initialState)

export const useProductContext = (): IProductState => {
  return useContext(ProductContext)
}

type Action = {
  type: 'UPDATE'
  payload: {
    sku: ISku
  }
}

export const reducer = (
  state: IProductState,
  action: Action,
): IProductState => {
  const { type, payload } = action

  switch (type) {
    case 'UPDATE':
      return {
        ...state,
        sku: payload.sku,
      }

    default:
      throw new Error(`Unknown company ${type} type`)
  }
}
